import React from 'react';

const RssFeedPage = (props) => (
	<div className="container main">
		<h2>RSS Feed</h2>
		<div className="row">
			<div className="col-sm-12">
				<p>¿Desea recibir notificaciones sobre las últimas retiradas de productos publicadas en el portal mundial de la OCDE?</p>
				<p>
					<a className={'rss-feed-link'} href={props.config.api + '/rss.xqy'}>Suscríbase a nuestro feed RSS.</a>
				</p>
				<p>También puede suscribirse a nuestro feed de varias otras maneras, incluyendo las siguientes:</p>
				<ul className={'rss-feed-options'}>
					<li>Copie la URL de la fuente RSS en su lector de noticias.</li>
					<li>Copie la URL de la fuente RSS en su navegador.</li>
				</ul>
			</div>
		</div>
	</div>
);

export default RssFeedPage;



// WEBPACK FOOTER //
// ./src/views/static/es/rss-feed.js